import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const app = document.getElementById('root')
ReactDOM.render(<App />,app);
